import {ProductType} from '../../products/products.enums';

function isProductSupportedTemplate(productType: ProductType): boolean {
  return productType !== ProductType.Promo;
}

export default isProductSupportedTemplate;
